import { render, staticRenderFns } from "./VRealData.vue?vue&type=template&id=bc7044ee&"
import script from "./VRealData.vue?vue&type=script&lang=js&"
export * from "./VRealData.vue?vue&type=script&lang=js&"
import style0 from "./VRealData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports